import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7c3aabac"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_cache-loader@4.1.0_webpack@4.47.0__css-loader@5.2.7_webp_aaeg4c7xsv2rwjah5qgerw23gy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiHeroSearchEstablishment: require('/data/www/klikvrijwilligers.nl/klikvrijwilligers/nuxt/components/ui/hero/SearchEstablishment.vue').default,FilterLetter: require('/data/www/klikvrijwilligers.nl/klikvrijwilligers/nuxt/components/filter/Letter.vue').default,FormMobileFilter: require('/data/www/klikvrijwilligers.nl/klikvrijwilligers/nuxt/components/form/MobileFilter.vue').default,UiButton: require('/data/www/klikvrijwilligers.nl/klikvrijwilligers/nuxt/components/ui/button/Button.vue').default,CompanyEntry: require('/data/www/klikvrijwilligers.nl/klikvrijwilligers/nuxt/components/company/Entry.vue').default,UiLoader: require('/data/www/klikvrijwilligers.nl/klikvrijwilligers/nuxt/components/ui/Loader.vue').default,UiPagination: require('/data/www/klikvrijwilligers.nl/klikvrijwilligers/nuxt/components/ui/pagination/Pagination.vue').default})
